import React from 'react';
import { useTranslation } from 'react-i18next';
import Alert, { AlertTypes } from 'components/Alert';
import Box from 'components/Box';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
function SessionEditAlert() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(Box, {
    my: "m",
    children: /*#__PURE__*/_jsxs(Alert, {
      type: AlertTypes.INFO,
      children: [t('alert_unsaved_playlist_changes'), ' ', t('alert_save_changes_before_session_management')]
    })
  });
}
export default SessionEditAlert;